import { useLingui } from '@lingui/react'
import type { FC } from 'react'

import { SHIPPING_DELAY_NOTIFICATION } from 'shared/experiments/consts'
import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import Experiment from 'views/components/utils/optimizely/Experiment'

const ShippingDelayNotification: FC = () => {
  const { i18n } = useLingui()
  return (
    <Experiment name={SHIPPING_DELAY_NOTIFICATION}>
      {({ isEnabled }) => {
        if (!isEnabled) return
        return (
          <Notification
            type={NOTIFICATION_TYPES.INFO}
            label={i18n._('general.notification.shippingDelay')}
          />
        )
      }}
    </Experiment>
  )
}

export default ShippingDelayNotification
